<div
    class="d-flex flex-column justify-content-center align-items-center position-relative fe-banner-landing-title"
>
    <img
        class="mw-100 d-none d-md-block"
        [src]="imageSrc"
        alt="{{ title || 'Banner image' }}"
    />
    <div
        class="container-card-landing-title-title position-absolute top-50 start-50 fw-bold mb-0 text-center d-flex flex-column justify-content-center align-items-center translate-middle"
    >
        <h2
            [ngClass]="{
                'placeholder placeholder-wave w-25': !title
            }"
        >
            {{ title || 'xxxxxxxx' }}
        </h2>
        <div class="subtitle-container mx-4">
            <p class="banner-subtitle">{{ subtitle || 'xxxxxx' }}</p>
        </div>
    </div>
</div>
